import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Sortable from 'components/theme/Sortable'
import {
  addSection,
  moveSection,
  selectSection,
} from 'actions/customForm/addOrEdit'
import itemUI from './itemUI'
import './form-finder.css'
import onClickOutside from 'react-onclickoutside'
import { DragIndicator } from '@material-ui/icons'
import './styles.scss'
import { withStyles } from '@material-ui/core'

class Sections extends Component {
  handleClickOutside = evt => {
    this.props.selectSection(null)
  }

  render() {
    const { sections, addSection, pageSelected, classes, isEditing } =
      this.props

    const pageBreaksWithIndices = sections
      .map((section, idx) => ({ ...section, idx }))
      .filter(el => el?.type === 'pagebreak')

    const pageBreakIndices = pageBreaksWithIndices.map(
      pagebreak => pagebreak.idx,
    )

    const pages = [
      ...pageBreakIndices.map((pageBreakIdx, idx) => idx),
      pageBreakIndices.length,
    ]

    let visibleSections = sections

    if (pageBreakIndices.length) {
      if (pageSelected === 0) {
        visibleSections = sections.slice(0, pageBreakIndices[0])
      } else if (pageSelected === pages.length - 1) {
        visibleSections = sections.slice(pageBreakIndices[pageSelected - 1])
      } /* (pageSelected !== pageBreakIndices.length - 1) */ else {
        visibleSections = sections.slice(
          pageBreakIndices[pageSelected - 1],
          pageBreakIndices[pageSelected],
        )
      }
    }

    const data = visibleSections.filter(el => {
      if (el?.type === 'pagebreak') {
        return false
      }
      return true
    })

    const dragHandle = () =>
      isEditing ? null : (
        <DragIndicator className={`dragHandle ${classes.dragHandle}`} />
      )

    return (
      <div className="vast_reach_custom_form">
        <Sortable
          // type="section"
          // accepts={['section', 'sectionPill']}
          dragHandle={dragHandle}
          data={data}
          itemUI={itemUI}
          onDragOver={(dragIndex, hoverIndex, itemType) => {
            this.props.moveSection(dragIndex, hoverIndex, pageBreakIndices)
          }}
          onDrop={(newSection, section, index) => {
            if (newSection.type === 'sectionPill') {
              addSection({
                newSection: { label: newSection.label, type: 'field' },
                section,
                index,
              })
            }
          }}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    sections: state.customForm.addOrEdit.form.sections.map(
      id => state.customForm.addOrEdit.sectionsByID[id],
    ),
    pageSelected: state.customForm.addOrEdit.pageSelected,
    isEditing: state.customForm.addOrEdit.sectionBeingEditedID,
  }),
  dispatch =>
    bindActionCreators({ moveSection, addSection, selectSection }, dispatch),
)(
  withStyles(theme => ({
    dragHandle: {
      display: 'none',
    },
  }))(onClickOutside(Sections)),
)
